

<!-- Indicateur de chargement -->
<div  class="loading-container">
    <mat-spinner [diameter]="30" [strokeWidth]="3" style="color: #7ad3f6;"></mat-spinner>
</div>